// extracted by css-extract-rspack-plugin
export default {"TriggerContainer":"n3_iQ","TriggerContainerIcon":"RyDzb","TextSchema":"VJQt6","BackButtonLabel":"M1qvn"};